import { createSelector } from 'reselect';
import { selectUserInformation } from './user-selector';
export const selectHostPermissions = createSelector(selectUserInformation, (user) => user === null || user === void 0 ? void 0 : user.permissions.host);
export const selectArchticsPermissions = createSelector(selectUserInformation, (user) => user === null || user === void 0 ? void 0 : user.permissions.archtics);
